const desc = `<html>
  <head>
    <meta content="text/html; charset=UTF-8" http-equiv="content-type" />
  </head>
  <body class="c7 doc-content">
    <p class="c1" dir="rtl">
      <span class="c2 bold">דבר</span><span class="c3">  [1934 05 14]</span>
    </p>
    <p class="c1" dir="rtl">
      <span class="c5 c6"
        >בתוך המאמר של א. ז. רבינוביץ יש ציטוט ממכתב של נחמה פוחצ&#39;בסקי</span
      ><span class="c5"> אליו.</span>
    </p>
    <p class="c1 c4" dir="rtl"><span class="c0"></span></p>
  </body>
</html>`;

export default desc;
